"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unpinMessage = exports.INBOX_UNPIN_MESSAGE = void 0;
var INBOX_UNPIN_MESSAGE = "inbox/UNPIN_MESSAGE";
exports.INBOX_UNPIN_MESSAGE = INBOX_UNPIN_MESSAGE;

var unpinMessage = function unpinMessage(messageId) {
  return {
    type: INBOX_UNPIN_MESSAGE,
    payload: {
      messageId: messageId
    }
  };
};

exports.unpinMessage = unpinMessage;